import { Grid, Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationProductSimilar from '@hook/parametrization/use-similar-product'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import TableGridScrollProductSimilar from '@component/Layout/TableGridScrollSimilarProduct'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBar from '@component/Parameterization/SimilarProduct/SelectedTableBar'

const ParametrizationSimilarProduct: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    filename,
    params,
    pagination,
    filters,
    filtersList,
    fetching,
    query,
    tableInteraction,
    actions,
    total,
    getData,
    getCenters,
    setFilename,
    handleUpdateParams,
    currentyDate,
    setFilters,
    clearAllFilters
  } = useParametrizationProductSimilar()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()

    getData(null, 1, 40, false)
    getFilters({
      companies: true,
      centers: true,
      productManagers: true
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Parametrização - Revisão">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={() => getData(null, 1, 40, false)}
            defaultDate={currentyDate}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || fetching || data.length === 0}
          />
          <SelectedTableBar />

          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os dados no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <Box>
              <Box paddingLeft={2}>
                <GridQuantity qtd={total.toString()} pagination={pagination} />
              </Box>

              <TableGridScrollProductSimilar
                id="parametrization-increment"
                headers={headers}
                query={query}
                data={data}
                entity="parametrization-increment"
                itsSortable={true}
                loading={fetching}
                actions={tableInteraction}
                height={tableHeight}
                pagination={pagination}
              />
            </Box>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ParametrizationSimilarProduct
